<div *ngIf="search.totalResults > 0 && !search.getQuery()" class="search-info">Showing {{ search.getPage() * 25 + 1}} -
    {{ getCurrentPageCount() }}
    of
    {{ getTotalResults() }} results.
</div>
<div *ngIf="search.totalResults > 0 && search.getQuery()" class="search-info">Showing {{ search.getPage() * 25 + 1}} -
    {{ getCurrentPageCount() }}
    of
    {{ getTotalResults() }} results <span class="hidden-xs">for "{{ search.getQuery() }}"</span>
</div>
<div *ngIf="search.totalResults == 0" class="search-info">Showing 0 results.</div>